/**
 * Code-split admin pages — loaded on demand when navigating /admin/* or /dashboard/*.
 * Keeps the main bundle smaller and speeds first paint on admin entry.
 *
 * importWithRetry: un reintento en race de deploy (chunk 404 breve).
 */
import { importWithRetry } from "@/lib/chunkLoadRecovery";
import { lazy, type ComponentType } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function lazyAdmin(loader: () => Promise<{ default: ComponentType<any> }>) {
  return lazy(() => importWithRetry(loader, 1, 350));
}

export const AdminDashboard = lazyAdmin(() => import("./AdminDashboard"));
export const AnalyticsDashboard = lazyAdmin(() => import("./AnalyticsDashboard"));
export const BusinessPulse = lazyAdmin(() => import("./BusinessPulse"));
export const RevenueAdmin = lazyAdmin(() => import("./RevenueAdmin"));
export const RecoveryAdmin = lazyAdmin(() => import("./RecoveryAdmin"));
export const ArgentinaWinCampaignAdmin = lazyAdmin(
  () => import("./ArgentinaWinCampaignAdmin"),
);
export const MemberLifecycleRecovery = lazyAdmin(() => import("./MemberLifecycleRecovery"));
export const InvestorKpiAdmin = lazyAdmin(() => import("./InvestorKpiAdmin"));
export const AccessControlAdmin = lazyAdmin(() => import("./AccessControlAdmin"));
export const FinanzasPersonalesAdmin = lazyAdmin(() => import("./FinanzasPersonalesAdmin"));
export const GeneradorInvitaciones = lazyAdmin(() => import("./GeneradorInvitaciones"));
export const BaseTemplateAdmin = lazyAdmin(() => import("./BaseTemplateAdmin"));
export const PremiumInviteAdmin = lazyAdmin(() => import("./PremiumInviteAdmin"));
export const ComunidadAdmin = lazyAdmin(() => import("./ComunidadAdmin"));
export const ReelsAdmin = lazyAdmin(() => import("./reels/ReelsHubPage"));
export const ReelsUploadPage = lazyAdmin(() => import("./reels/ReelsUploadPage"));
export const ReelsFeedPage = lazyAdmin(() => import("./reels/ReelsFeedPage"));
export const ReelsShareLinksPage = lazyAdmin(
  () => import("./reels/ReelsShareLinksPage"),
);
export const ReelsSecretSharePage = lazyAdmin(
  () => import("./reels/ReelsSecretSharePage"),
);
export const PortfolioAdmin = lazyAdmin(() => import("./PortfolioAdmin"));
export const WatermarkShortcutAdmin = lazyAdmin(
  () => import("./WatermarkShortcutAdmin"),
);
export const MediaKitAdmin = lazyAdmin(() => import("./MediaKitAdmin"));
export const MediaKitAnalyticsAdmin = lazyAdmin(
  () => import("./MediaKitAnalyticsAdmin"),
);
export const AudiovisualAdmin = lazyAdmin(() => import("./AudiovisualAdmin"));
export const WishlistAdmin = lazyAdmin(() => import("./WishlistAdmin"));
export const CountryTemplateAdmin = lazyAdmin(() => import("./CountryTemplateAdmin"));
export const GeoTrafficDashboard = lazyAdmin(() => import("./GeoTrafficDashboard"));
export const PhotoAnalyticsAdmin = lazyAdmin(() => import("./PhotoAnalyticsAdmin"));
export const WebTemplatesAnalyticsAdmin = lazyAdmin(() => import("./WebTemplatesAnalyticsAdmin"));
export const MuxAnalyticsAdmin = lazyAdmin(() => import("./MuxAnalyticsAdmin"));
export const MuxConversionAdmin = lazyAdmin(() => import("./MuxConversionAdmin"));
export const ConversionHealthAdmin = lazyAdmin(() => import("./ConversionHealthAdmin"));
export const ConversionOrchestratorAdmin = lazyAdmin(
  () => import("./ConversionOrchestratorAdmin"),
);
export const IpLocateHealthAdmin = lazyAdmin(() => import("./IpLocateHealthAdmin"));
export const WorkerFlagsAdmin = lazyAdmin(() => import("./WorkerFlagsAdmin"));
export const ConfigHealthAdmin = lazyAdmin(() => import("./ConfigHealthAdmin"));
export const NotificationsHealth = lazyAdmin(() => import("./NotificationsHealth"));
export const ActiveMembersAdmin = lazyAdmin(() => import("./ActiveMembersAdmin"));
export const EmailBroadcast = lazyAdmin(() => import("./EmailBroadcast"));
export const AdminAuditLog = lazyAdmin(() => import("./AdminAuditLog"));
export const MembershipApprovals = lazyAdmin(() => import("./MembershipApprovals"));
export const FreeMemberApprovals = lazyAdmin(() => import("./FreeMemberApprovals"));
export const StripeDisputesAdmin = lazyAdmin(() => import("./StripeDisputesAdmin"));
export const StripePaymentsConfigAdmin = lazyAdmin(() => import("./StripePaymentsConfigAdmin"));
export const SorprendemeConfigAdmin = lazyAdmin(() => import("./SorprendemeConfigAdmin"));
export const WhatsAppBroadcastAdmin = lazyAdmin(() => import("./WhatsAppBroadcastAdmin"));
export const DualCtaHomeAdmin = lazyAdmin(() => import("./DualCtaHomeAdmin"));
export const DualCtaVideoTemplatesAdmin = lazyAdmin(() => import("./VipVideoAssetsAdmin"));
export const VisitorExperienceAdmin = lazyAdmin(() => import("./VisitorExperienceAdmin"));
export const VisitorExperienceFunnelsAdmin = lazyAdmin(
  () => import("./VisitorExperienceFunnelsAdmin"),
);
export const MercadoPagoPlansAdmin = lazyAdmin(() => import("./MercadoPagoPlansAdmin"));
// Note: file name VipVideoAssetsAdmin.tsx is legacy (for DB table/api path "vip-video-assets");
// user-facing name and component is DualCtaVideoTemplatesAdmin for coherence with /admin/dual-cta-home and DualCTAVideoLanding.
